import {
  DownOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
  PlusOutlined,
  PrinterOutlined,
  SearchOutlined
} from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Dropdown,
  Input,
  Menu,
  Pagination,
  Popconfirm,
  Row,
  Space,
  Table,
  Tooltip,
  message,
} from 'antd';
import dayjs from 'dayjs';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { CSVLink } from 'react-csv';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { font } from '../../Common/font';
import ImportDataModal from '../../Common/ImportDataModal';
import { ReactComponent as Customercategory } from '../../Images/customercategory.svg';
import { ReactComponent as Sitelocation } from '../../Images/sitelocation.svg';

import { ReactComponent as Alloy } from '../../Images/alloy.svg';
import logo from '../../Images/alux-logo.png';
import { ReactComponent as Archive } from '../../Images/archive.svg';
import { ReactComponent as Archiveicon } from '../../Images/Archiveicon.svg';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as ColumnList } from '../../Images/ColumnList.svg';
import { ReactComponent as Conversation } from '../../Images/conversation.svg';
import { ReactComponent as Customertype } from '../../Images/customertype.svg';
import { ReactComponent as EditIcon } from '../../Images/EditIcon.svg';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';
import formatFile from "../../Images/sample-files/customer-format.xlsx";
import { ReactComponent as Temper } from '../../Images/temper.svg';
import { ReactComponent as ViewIcon } from '../../Images/ViewIcon.svg';
import { createActivityLog } from '../../slices/activity-log';
import { deleteCustomer, fetchCustomerList, resetCustomerList } from '../../slices/customer';
import { fetchAndSetIpAddress } from '../../slices/ipSlice';
import { fetchWorkOrderReport } from '../../slices/work-order';


function CustomerList() {
  let navigate = useNavigate();
  const csvRef = useRef();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]); // Track
  const { user: currentUser } = useSelector(state => state.auth);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const throttleTimer = useRef(null);
  const [search, setSearch] = useState(
    localStorage.getItem('customerList') || '',
  );
  const [inputValue, setInputValue] = useState(
    localStorage.getItem('customerList') || '',
  );
  const lastExecution = useRef(0);
  const dispatch = useDispatch();
  const { data = [], totalRecord, status } = useSelector(state => state.customer);
  const [orderBy, setOrderBy] = useState('');
  const [page, setPage] = useState(1);
  const [pagesize, setPageSize] = useState(100);
  const [AllcsvData, setAllCsvData] = useState([]);
  const [allPdfLoading, setAllPdfLoading] = useState(false);
  const [allCsvLoading, setAllCsvLoading] = useState(false);
  const handleColumnVisibilityChange = checkedValues => {
    setCheckedList(checkedValues);
  };
  const [checkedList, setCheckedList] = useState([
    'SrNo',
    'customer_name',
    '',
    'officeAddress',
    'action',
  ]);

    const ipAddress = useSelector(state => state.ip.ipAddress);
  useEffect(() => {
    if (!ipAddress) {
      dispatch(fetchAndSetIpAddress());
    }
  }, [ipAddress, dispatch]);
  
  const handleEdit = data => {
    navigate(`/edit-customer/${data.id}`);
  };
  const handleDelete = id => {
    if (!id) {
      message.error('Missing ID for deletion!');
      return;
    }

    dispatch(deleteCustomer(id))
      .unwrap()
      .then(() => {
        message.success('Customer Archive Successfully!');
      })
      .catch(error => {
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error); // Handle string error
        } else if (error instanceof Error) {
          message.error(error.message); // Handle Error object
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'SrNo',
      key: 'SrNo',
      width: 60,
      render: (text, record, index) => {
        return (page - 1) * pagesize + index + 1;
      },
    },
    {
      title: 'Name',
      dataIndex: 'customer_name',
      key: 'customer_name',
      sorter: true,
      width: 200,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      width: 250,
      sorter: true,
      render: email => {
        return <span>{email || 'N/A'}</span>;
      },
    },
    {
      title: 'GSTIN',
      dataIndex: 'gstin_number',
      key: 'gstin_number',
      width: 100,
      sorter: true,
      render: gstin_number => {
        return <span>{gstin_number ? gstin_number : 'N/A'}</span>;
      },
    },
    {
      title: 'GST Type',
      dataIndex: 'gst_type',
      key: 'gst_type',
      width: 100,
      render: gst_type => {
        return <span>{gst_type ? gst_type : 'N/A'}</span>;
      },
    },
    {
      title: 'Pan Number',
      dataIndex: 'pan_number',
      key: 'pan_number',
      width: 130,
      sorter: true,
      render: pan_number => {
        return <span>{pan_number ? pan_number : 'N/A'}</span>;
      },
    },
    {
      title: 'Udyam Number',
      dataIndex: 'udyam_no',
      width: 130,
      key: 'udyam_no',
      sorter: true,
      render: udyam_no => {
        return <span>{udyam_no ? udyam_no : 'N/A'}</span>;
      },
    },
    {
      title: 'Customer Type',
      dataIndex: 'customer_type',
      key: 'customer_type',
      width: 130,
      render: customer_type => {
        return <span>{customer_type?.name ? customer_type.name : 'N/A'}</span>;
      },
    },
    {
      title: 'Delivery Days',
      dataIndex: 'delivery_days',
      key: 'delivery_days',
      width: 100,
      render: delivery_days => {
        return <span>{delivery_days ? delivery_days : 'N/A'}</span>;
      },
    },
    {
      title: 'Applicable GST',
      dataIndex: 'applicable_gst',
      key: 'applicable_gst',
      width: 100,
      render: applicable_gst => {
        return <span>{applicable_gst ? applicable_gst : 'N/A'}</span>;
      },
    },
    {
      title: 'Customer Profile No ',
      width: 130,
      dataIndex: 'customer_section_no',
      key: 'customer_section_no',
      render: customer_section_no => {
        return <span>{customer_section_no ? customer_section_no : 'N/A'}</span>;
      },
    },

    {
      title: 'Office Address',
      dataIndex: 'officeAddress',
      key: 'officeAddress',
      sorter: false,
      render: (text, record) => {
        const address = `${record?.office_address_shop || ''} 
                        ${record?.office_address_area || ''} 
                        ${record?.office_address_landmark || ''} 
                        ${record?.office_address_city || ''} 
                        ${record?.office_address_state || ''}- 
                        ${record?.office_address_pin_code || ''}`
          .trim()
          .toUpperCase(); // Convert to uppercase

        return <span>{address ? address : 'N/A'}</span>;
      },
    },
    {
      title: 'Factory Address',
      dataIndex: 'factoryAddress',
      key: 'factoryAddress',
      sorter: false,
      render: (text, record) => {
        const address = `${record?.factory_address_shop || ''} 
                        ${record?.factory_address_area || ''} 
                        ${record?.factory_address_landmark || ''} 
                        ${record?.factory_address_city || ''} 
                        ${record?.factory_address_state || ''}- 
                        ${record?.factory_address_pin_code || ''}`
          .trim()
          .toUpperCase(); // Convert to uppercase

        return <span>{address ? address : 'N/A'}</span>;
      },
    },
    {
      title: 'Contact Number',
      dataIndex: 'phone_number',
      key: 'phone_number',
      width: 130,
      render: record => {
        return <span>+{record} </span>;
      },
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 100,
      render: record => {
        return (
          <span>
            {record ? dayjs(record).format('DD-MM-YYYY HH:mm') : 'N/A'}{' '}
          </span>
        );
      },
    },
    {
      title: 'Created By',
      dataIndex: 'created_by',
      key: 'created_by',
      width: 100,
      render: record => {
        return (
          <span>
            {record ? `${record.first_name} ${record.last_name}` : 'N/A'}{' '}
          </span>
        );
      },
    },
    {
      title: 'Updated At',
      dataIndex: 'updated_at',
      key: 'updated_at',
      width: 100,
      render: record => {
        return (
          <span>
            {record && record.trim()
              ? dayjs(record).format('DD-MM-YYYY HH:mm')
              : 'N/A'}
          </span>
        );
      },
    },
    {
      title: 'Updated By',
      dataIndex: 'updated_by',
      key: 'updated_by',
      width: 100,
      render: record => {
        return (
          <span>
            {record && record.first_name?.trim() && record.last_name?.trim()
              ? `${record.first_name} ${record.last_name}`
              : 'N/A'}
          </span>
        );
      },
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      fixed: 'right',
      width: 130,
      render: (_, record) => (
        <Space size="small">
          {currentUser.permissions.permissions.customer.includes(
            'view_customer',
          ) && (
              <Tooltip placement="top" title={'View Customer'}>
                <Link to={`/view-customer/${record.id}`}>
                  <ViewIcon />
                </Link>
              </Tooltip>
            )}
          {currentUser.permissions.permissions.customer.includes(
            'change_customer',
          ) && (
              <Tooltip placement="top" title={'Edit'}>
                <span onClick={() => handleEdit(record)}>
                  <EditIcon style={{ cursor: 'pointer' }} />
                </span>
              </Tooltip>
            )}
          {currentUser.permissions.permissions.customer.includes(
            'print_customer_workorder_report_pdf_copy',
          ) && (
              <Tooltip placement="top" title={'Print Work Order Report'}>
                <span
                  onClick={() =>
                    navigate(`/print-customer-workorder-report/${record.id}`)
                  }
                >
                  <PrinterOutlined
                    style={{ cursor: 'pointer', fontSize: '17px' }}
                  />
                </span>
              </Tooltip>
            )}
          {currentUser.permissions.permissions.customer.includes(
            'delete_customer',
          ) && (
              <Link>
                <Tooltip title="Archive">
                  <Popconfirm
                    title="Are you sure you want to archive this record?"
                    onConfirm={() => handleDelete(record.id)}
                    onCancel={() => message.info('Action cancelled')}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Archive style={{ cursor: 'pointer' }} />
                  </Popconfirm>
                </Tooltip>
              </Link>
            )}
        </Space>
      ),
    },
  ];
  const filteredColumns = columns.filter(column =>
    checkedList.includes(column.key),
  );

  const rowSelection = {
    selectedRowKeys,
    onChange: selectedRowKeys => setSelectedRowKeys(selectedRowKeys),
  };

  useEffect(() => {
    dispatch(
      fetchCustomerList({
        page,
        pagesize,
        ...(search && { search: search }),
        ...(orderBy && { ordering: orderBy }),
      }),
    );
  }, [dispatch, page, pagesize, search, orderBy]);
  const refreshTable = () => {
    dispatch(resetCustomerList());
    dispatch(
      fetchCustomerList({
        page: 1,
        pagesize,
        ...(search && { search }),
        ...(orderBy && { ordering: orderBy }),
      })
    );
  };
  const generateCsvListData = async () => {
    try {
      setAllCsvLoading(true);
      const response = await dispatch(
        fetchCustomerList({
          page: 1,
          pagesize: 5000,
        }),
      );

      const data = response?.payload?.results?.data || [];

      const rows = data.map((item, index) => {
        const row = {
          SrNo: (page - 1) * pagesize + index + 1,
        };

        allCsvColumns
          .filter(col => checkedList.includes(col.field))
          .forEach(col => {
            switch (col.field) {
              case 'SrNo':
                row.SrNo = index + 1;
                break;
              case 'customer_name':
                row.customerName = item?.customer_name || 'N/A';
                break;
              case 'factoryAddress':
                row.factoryAddress = [
                  item?.factory_address_shop || 'N/A',
                  item?.factory_address_area || 'N/A',
                  item?.factory_address_landmark || 'N/A',
                  item?.factory_address_city || 'N/A',
                  item?.factory_address_state || 'N/A',
                  item?.factory_address_pin_code || 'N/A',
                ]
                  .filter(text => text !== 'N/A')
                  .join(', ')
                  .toUpperCase();
                break;
              case 'officeAddress':
                row.officeAddress = [
                  item?.office_address_shop || 'N/A',
                  item?.office_address_area || 'N/A',
                  item?.office_address_landmark || 'N/A',
                  item?.office_address_city || 'N/A',
                  item?.office_address_state || 'N/A',
                  item?.office_address_pin_code || 'N/A',
                ]
                  .filter(text => text !== 'N/A')
                  .join(', ')
                  .toUpperCase();
                break;
              case 'phone_number':
                row.phoneNumber = item?.phone_number || 'N/A';
                break;
              case 'gstin_number':
                row.gstinNumber = item?.gstin_number || 'N/A';
                break;
              case 'pan_number':
                row.panNumber = item?.pan_number || 'N/A';
                break;
              case 'udyam_no':
                row.udyamNumber = item?.udyam_no || 'N/A';
                break;
              case 'gst_type':
                row.gstType = item?.gst_type || 'N/A';
                break;
              case 'created_at':
                row.createdAt = item.created_at
                  ? moment(item.created_at).format('DD-MM-YYYY')
                  : 'N/A';
                break;
              case 'created_by':
                row.createdBy = item.created_by
                  ? `${item.created_by.first_name} ${item.created_by.last_name}`
                  : 'N/A';
                break;
              case 'updated_at':
                row.updatedAt = item.updated_at
                  ? moment(item.updated_at).format('DD-MM-YYYY')
                  : 'N/A';
                break;
              case 'updated_by':
                row.updatedBy = item.updated_by
                  ? `${item.updated_by.first_name} ${item.updated_by.last_name}`
                  : 'N/A';
                break;
              case 'account_group':
                row.accountGroup = item?.account_group?.name || 'N/A';
                break;
              case 'customer_type':
                row.customerType = item?.customer_type?.name || 'N/A';
                break;
              case 'delivery_days':
                row.deliveryDays = item?.delivery_days || 'N/A';
                break;
              case 'applicable_gst':
                row.applicableGst = item?.applicable_gst || 'N/A';
                break;
              case 'customer_section_no':
                row.customerSectionNo = item?.customer_section_no || 'N/A';
                break;
              case 'bank_name':
                row.bankName = item?.bank_name || 'N/A';
                break;
              case 'bank_account_number':
                row.bankAccountNumber = item?.bank_account_number || 'N/A';
                break;
              case 'bank_ifsc_code':
                row.bankIfscCode = item?.bank_ifsc_code || 'N/A';
                break;
              case 'bank_branch_address':
                row.bankBranchAddress = item?.bank_branch_address || 'N/A';
                break;
              case 'email':
                row.email = item?.email || 'N/A';
                break;
              default:
                row[col.dataKey] = 'N/A';
            }
          });

        return row;
      });

      setAllCsvData(rows);
      setTimeout(() => {
        if (csvRef.current?.link) {
          csvRef.current.link.click();
        }
      }, 0);
    } catch (error) {
      console.error('CSV generation failed:', error);
    } finally {
      setAllCsvLoading(false);
    }
  };

  const dataSource = data.map((item, index) => ({
    ...item,
    key: item.id || index,
  }));

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter?.columnKey && sorter.order) {
      const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
      setOrderBy(orderBy);
    }
  };
  const debounceTimeout = useRef(null);

  const handleSearch = e => {
    const value = e.target.value;
    setInputValue(value);
    setSearch(value);
    localStorage.setItem('customerList', value); // save to localStorage
  };
  const resetFilter = () => {
    setSearch('');
    setInputValue('');
    setOrderBy(null); // if applicable

    localStorage.removeItem('customerList');
    dispatch(fetchCustomerList({ page: 1, pagesize }));
  };

  const handlePageChange = newPage => {
    setPage(newPage);
    setOrderBy('');
  };
  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = 'id';

    if (sortField === 'pan_number' && sortOrder === 'ascend') {
      sortingEnumKey = 'pan_number';
    }
    if (sortField === 'pan_number' && sortOrder === 'descend') {
      sortingEnumKey = '-pan_number';
    }
    if (sortField === 'email' && sortOrder === 'ascend') {
      sortingEnumKey = 'email';
    }
    if (sortField === 'email' && sortOrder === 'descend') {
      sortingEnumKey = '-email';
    }
    if (sortField === 'gstin_number' && sortOrder === 'ascend') {
      sortingEnumKey = 'gstin_number';
    }
    if (sortField === 'gstin_number' && sortOrder === 'descend') {
      sortingEnumKey = '-gstin_number';
    }
    if (sortField === 'udyam_no' && sortOrder === 'ascend') {
      sortingEnumKey = 'udyam_no';
    }
    if (sortField === 'udyam_no' && sortOrder === 'descend') {
      sortingEnumKey = '-udyam_no';
    }
    if (sortField === 'customer_name' && sortOrder === 'ascend') {
      sortingEnumKey = 'customer_name';
    }
    if (sortField === 'customer_name' && sortOrder === 'descend') {
      sortingEnumKey = '-customer_name';
    }
    if (sortField === 'phone_number' && sortOrder === 'ascend') {
      sortingEnumKey = 'phone_number';
    }
    if (sortField === 'phone_number' && sortOrder === 'descend') {
      sortingEnumKey = '-phone_number';
    }
    if (sortField === 'created_at' && sortOrder === 'ascend') {
      sortingEnumKey = 'created_at';
    }
    if (sortField === 'created_at' && sortOrder === 'descend') {
      sortingEnumKey = '-created_at';
    }
    if (sortField === 'created_by' && sortOrder === 'ascend') {
      sortingEnumKey = 'created_by';
    }
    if (sortField === 'created_by' && sortOrder === 'descend') {
      sortingEnumKey = '-created_by';
    }
    if (sortField === 'updated_at' && sortOrder === 'ascend') {
      sortingEnumKey = 'updated_at';
    }
    if (sortField === 'updated_at' && sortOrder === 'descend') {
      sortingEnumKey = '-updated_at';
    }
    if (sortField === 'updated_by' && sortOrder === 'ascend') {
      sortingEnumKey = 'updated_by';
    }
    if (sortField === 'updated_by' && sortOrder === 'descend') {
      sortingEnumKey = '-updated_by';
    }
    return sortingEnumKey;
  };

  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item key="columnMenu">
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Checkbox value="SrNo" disabled>
                Sr. No.
              </Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="customer_name">Name</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="email">Email</Checkbox>
            </Col>

            <Col xs={24} md={12}>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="customer_type">Customer Type</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="delivery_days">Delivery Days</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="udyam_no">Udyam No</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="applicable_gst">Applicable GST</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="customer_section_no">
                Customer Profile No
              </Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="factoryAddress">Factory Address</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="officeAddress">Office Address</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="phone_number">Contact Number</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="gstin_number">GSTIN No</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="gst_type">GST Type</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="pan_number">Pan Number</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="created_at">Created At</Checkbox>
            </Col>

            <Col xs={24} md={12}>
              <Checkbox value="created_by">Created By</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="updated_at">Updated At</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="updated_by">Updated By</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="action" disabled>
                Action
              </Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  const exportCustomerPDF = data => {
    const pdf = new jsPDF('l', 'pt', 'a4');
    pdf.addFileToVFS('WorkSans-normal.ttf', font);
    pdf.addFont('WorkSans-normal.ttf', 'WorkSans', 'normal');
    pdf.setFont('WorkSans');

    const allColumns = [
      { header: 'Sr No.', dataKey: 'SrNo', field: 'SrNo' },
      { header: 'Customer Name', dataKey: 'customerName', field: 'customer_name' },
      { header: 'Email', dataKey: 'email', field: 'email' },
      { header: 'GSTIN Number', dataKey: 'gstinNumber', field: 'gstin_number' },
      { header: 'GST Type', dataKey: 'gstType', field: 'gst_type' },
      { header: 'PAN Number', dataKey: 'panNumber', field: 'pan_number' },
      { header: 'Udyam Number', dataKey: 'udyamNumber', field: 'udyam_no' },
      { header: 'Customer Type', dataKey: 'customerType', field: 'customer_type' },
      { header: 'Delivery Days', dataKey: 'deliveryDays', field: 'delivery_days' },
      { header: 'Applicable GST', dataKey: 'applicableGst', field: 'applicable_gst' },
      { header: 'Customer Profile No.', dataKey: 'customerSectionNo', field: 'customer_section_no' },
      { header: 'Factory Address', dataKey: 'factoryAddress', field: 'factoryAddress' },
      { header: 'Office Address', dataKey: 'officeAddress', field: 'officeAddress' },
      { header: 'Phone Number', dataKey: 'phoneNumber', field: 'phone_number' },
      { header: 'Created At', dataKey: 'createdAt', field: 'created_at' },
      { header: 'Created By', dataKey: 'createdBy', field: 'created_by' },
      { header: 'Updated At', dataKey: 'updatedAt', field: 'updated_at' },
      { header: 'Updated By', dataKey: 'updatedBy', field: 'updated_by' },
    ];

    const columns = allColumns.filter(col => checkedList.includes(col.field));

    const rows = dataSource.map((item, index) => {
      const row = { SrNo: '1' };
      columns.forEach(col => {
        switch (col.field) {
          case 'SrNo':
            row.SrNo = (page - 1) * pagesize + index + 1;
            break;
          case 'customer_name':
            row.customerName = item.customer_name || 'N/A';
            break;
          case 'factoryAddress':
            row.factoryAddress =
              [
                item?.factory_address_shop,
                item?.factory_address_area,
                item?.factory_address_landmark,
                item?.factory_address_city,
                item?.factory_address_state,
                item?.factory_address_pin_code,
              ]
                .filter(Boolean)
                .join(', ')
                .toUpperCase() || 'N/A';
            break;
          case 'officeAddress':
            row.officeAddress =
              [
                item?.office_address_shop,
                item?.office_address_area,
                item?.office_address_landmark,
                item?.office_address_city,
                item?.office_address_state,
                item?.office_address_pin_code,
              ]
                .filter(Boolean)
                .join(', ')
                .toUpperCase() || 'N/A';
            break;
          case 'created_at':
            row.createdAt = item?.created_at
              ? moment(item.created_at).format('DD-MM-YYYY')
              : 'N/A';
            break;
          case 'created_by':
            row.createdBy = item?.created_by
              ? `${item.created_by.first_name} ${item.created_by.last_name}`
              : 'N/A';
            break;
          case 'updated_at':
            row.updatedAt = item?.updated_at
              ? moment(item.updated_at).format('DD-MM-YYYY')
              : 'N/A';
            break;
          case 'updated_by':
            row.updatedBy = item?.updated_by
              ? `${item.updated_by.first_name} ${item.updated_by.last_name}`
              : 'N/A';
            break;
          case 'customer_type':
            row.customerType = item?.customer_type?.name || 'N/A';
            break;
          default:
            row[col.dataKey] = item[col.field] || 'N/A';
            break;
        }
      });
      return row;
    });

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    pdf.setFontSize(16);
    pdf.text('Customer', pageWidth / 2, 40, { align: 'center' });

    pdf.autoTable({
      columns,
      body: rows,
      startY: 80,
      theme: 'grid',
      margin: { top: 80, right: 15, left: 15, bottom: 40 },
      tableWidth: 'auto',
      styles: {
        halign: 'center',
        overflow: 'linebreak',
        cellPadding: 2,
        fontSize: 9,
      },
      headStyles: {
        textColor: [0, 0, 0],
        fontStyle: 'bold',
        fillColor: false,
        halign: 'center',
      },
      columnStyles: {
        SrNo: { halign: 'center', cellWidth: 40 },
      },
      didDrawPage: data => {
        const pageCount = pdf.internal.getNumberOfPages();
        const currentPage = pdf.internal.getCurrentPageInfo().pageNumber;

        if (currentPage === 1) {
          pdf.addImage(logo, 'PNG', pageWidth - 100, 10, 90, 30);
        }

        pdf.setFontSize(8);
        const dateTime = moment().format('DD-MM-YYYY HH:mm:ss');
        pdf.text(dateTime, 15, pageHeight - 10);
        pdf.text(`Page ${currentPage} of ${pageCount}`, pageWidth - 60, pageHeight - 10);
      },
    });

    pdf.save(`customer_${new Date().toISOString().split('T')[0]}.pdf`);

    dispatch(
      createActivityLog({
        action: 'DOWNLOAD',
        module_name: 'Customer',
        ip_address: ipAddress,
        discription: 'Customer pdf download successfully!',
      })
    );
  };

  const activityLog = async () => {
    dispatch(
      createActivityLog({
        action: 'DOWNLOAD',
        module_name: 'Customer',
        ip_address: ipAddress,
        discription: 'Customer excel download successfully!',
      }),
    );
  };
  const allCsvColumns = [
    { header: 'Sr No.', dataKey: 'SrNo', field: 'SrNo' },
    { header: 'Customer Name', dataKey: 'customerName', field: 'customer_name' },
    { header: 'Email', dataKey: 'email', field: 'email' },
    { header: 'GSTIN Number', dataKey: 'gstinNumber', field: 'gstin_number' },
    { header: 'GST Type', dataKey: 'gstType', field: 'gst_type' },
    { header: 'PAN Number', dataKey: 'panNumber', field: 'pan_number' },
    { header: 'Udyam Number', dataKey: 'udyamNumber', field: 'udyam_no' },
    { header: 'Customer Type', dataKey: 'customerType', field: 'customer_type' },
    { header: 'Delivery Days', dataKey: 'deliveryDays', field: 'delivery_days' },
    {
      header: 'Applicable GST',
      dataKey: 'applicableGst',
      field: 'applicable_gst',
    },
    {
      header: 'Customer Profile No.',
      dataKey: 'customerSectionNo',
      field: 'customer_section_no',
    },
    {
      header: 'Office Address',
      dataKey: 'officeAddress',
      field: 'officeAddress',
    },
    {
      header: 'Factory Address',
      dataKey: 'factoryAddress',
      field: 'factoryAddress',
    },
    { header: 'Contact Number', dataKey: 'phoneNumber', field: 'phone_number' },
    { header: 'Created At', dataKey: 'createdAt', field: 'created_at' },
    { header: 'Created By', dataKey: 'createdBy', field: 'created_by' },
    { header: 'Updated At', dataKey: 'updatedAt', field: 'updated_at' },
    { header: 'Updated By', dataKey: 'updatedBy', field: 'updated_by' },
  ];

  const csvHeaders = allCsvColumns
    .filter(col => checkedList.includes(col.field)) // Filter only selected columns
    .map(col => ({
      label: col.header, // CSV column header
      key: col.dataKey, // Corresponding data key
    }));

  const csvListData = dataSource.map((item, index) => {
    const row = {
      SrNo: (page - 1) * pagesize + index + 1, // Calculate Sr. No. based on page and limit
    };
    allCsvColumns
      .filter(col => checkedList.includes(col.field))
      .forEach(col => {
        switch (col.field) {
          case 'SrNo':
            row.SrNo = index + 1; // Ensuring Sr No. is correctly assigned
            break;
          case 'customer_name':
            row.customerName = item?.customer_name || 'N/A';
            break;
          case 'factoryAddress':
            row.factoryAddress = [
              item?.factory_address_shop || 'N/A',
              item?.factory_address_area || 'N/A',
              item?.factory_address_landmark || 'N/A',
              item?.factory_address_city || 'N/A',
              item?.factory_address_state || 'N/A',
              item?.factory_address_pin_code || 'N/A',
            ]
              .filter(text => text !== 'N/A')
              .join(', ')
              .toUpperCase();
            break;
          case 'officeAddress':
            row.officeAddress = [
              item?.office_address_shop || 'N/A',
              item?.office_address_area || 'N/A',
              item?.office_address_landmark || 'N/A',
              item?.office_address_city || 'N/A',
              item?.office_address_state || 'N/A',
              item?.office_address_pin_code || 'N/A',
            ]
              .filter(text => text !== 'N/A')
              .join(', ')
              .toUpperCase();
            break;
          case 'phone_number':
            row.phoneNumber = item?.phone_number || 'N/A';
            break;
          case 'gstin_number':
            row.gstinNumber = item?.gstin_number || 'N/A';
            break;
          case 'pan_number':
            row.panNumber = item?.pan_number || 'N/A';
            break;
          case 'udyam_no':
            row.udyamNumber = item?.udyam_no || 'N/A';
            break;
          case 'gst_type':
            row.gstType = item?.gst_type || 'N/A';
            break;
          case 'created_at':
            row.createdAt = item.created_at
              ? moment(item.created_at).format('DD-MM-YYYY')
              : 'N/A';
            break;
          case 'created_by':
            row.createdBy = item.created_by
              ? `${item.created_by.first_name} ${item.created_by.last_name}`
              : 'N/A';
            break;
          case 'updated_at':
            row.updatedAt = item.updated_at
              ? moment(item.updated_at).format('DD-MM-YYYY')
              : 'N/A';

            break;
          case 'updated_by':
            row.updatedBy = item.created_by
              ? `${item.created_by.first_name} ${item.created_by.last_name}`
              : 'N/A';
            break;
          case 'customer_type':
            row.customerType = item?.customer_type?.name || 'N/A';
            break;
          case 'delivery_days':
            row.deliveryDays = item?.delivery_days || 'N/A';
            break;
          case 'applicable_gst':
            row.applicableGst = item?.applicable_gst || 'N/A';
            break;
          case 'customer_section_no':
            row.customerSectionNo = item?.customer_section_no || 'N/A';
            break;
          case 'bank_name':
            row.bankName = item?.bank_name || 'N/A';
            break;
          case 'bank_account_number':
            row.bankAccountNumber = item?.bank_account_number || 'N/A';
            break;
          case 'bank_ifsc_code':
            row.bankIfscCode = item?.bank_ifsc_code || 'N/A';
            break;
          case 'bank_branch_address':
            row.bankBranchAddress = item?.bank_branch_address || 'N/A';
            break;
          case 'email':
            row.email = item?.email || 'N/A';
            break;
          default:
            row[col.dataKey] = 'N/A';
        }
      });
    return row;
  });
  const Allcsvheaders = allCsvColumns.map(col => ({
    label: col.header,
    key: col.dataKey,
  }));

  const handleAllPdfDownload = async () => {
    setAllPdfLoading(true);
    try {
      const response = await dispatch(
        fetchCustomerList({
          page,
          pagesize: 5000, // explicitly setting it
        }),
      );
      const pdf = new jsPDF('l', 'pt', 'a4');
      pdf.addFileToVFS('WorkSans-normal.ttf', font);
      pdf.addFont('WorkSans-normal.ttf', 'WorkSans', 'normal');
      pdf.setFont('WorkSans');
      const allColumns = [
        { header: 'Sr No.', dataKey: 'SrNo', field: 'SrNo' },
        {
          header: 'Customer Name',
          dataKey: 'customerName',
          field: 'customer_name',
        },
        { header: 'Email', dataKey: 'email', field: 'email' },
        { header: 'GSTIN Number', dataKey: 'gstinNumber', field: 'gstin_number' },
        { header: 'GST Type', dataKey: 'gstType', field: 'gst_type' },
        { header: 'PAN Number', dataKey: 'panNumber', field: 'pan_number' },
        { header: 'Udyam Number', dataKey: 'udyamNumber', field: 'udyam_no' },
        {
          header: 'Account Group',
          dataKey: 'accountGroup',
          field: 'account_group',
        },
        {
          header: 'Customer Type',
          dataKey: 'customerType',
          field: 'customer_type',
        },
        {
          header: 'Delivery Days',
          dataKey: 'deliveryDays',
          field: 'delivery_days',
        },
        {
          header: 'Applicable GST',
          dataKey: 'applicableGst',
          field: 'applicable_gst',
        },
        {
          header: 'Customer Profile No.',
          dataKey: 'customerSectionNo',
          field: 'customer_section_no',
        },
        {
          header: 'Factory Address',
          dataKey: 'factoryAddress',
          field: 'factoryAddress',
        },
        {
          header: 'Office Address',
          dataKey: 'officeAddress',
          field: 'officeAddress',
        },
        { header: 'Phone Number', dataKey: 'phoneNumber', field: 'phone_number' },
        { header: 'Created At', dataKey: 'createdAt', field: 'created_at' },
        { header: 'Created By', dataKey: 'createdBy', field: 'created_by' },
        { header: 'Updated At', dataKey: 'updatedAt', field: 'updated_at' },
        { header: 'Updated By', dataKey: 'updatedBy', field: 'updated_by' },
      ];
      const columns = allColumns.filter(col => checkedList.includes(col.field));
      const rows = response?.payload?.results?.data.map((item, index) => {
        const row = {
          SrNo: index + 1, // Assigning sequential serial numbers
        };
        columns.forEach(col => {
          switch (col.field) {
            case 'sr_no':
              row.SrNo = index + 1; // Ensuring Sr No. is correctly assigned
              break;
            case 'customer_name':
              row.customerName = item.customer_name || 'N/A';
              break;
            case 'factoryAddress':
              row.factoryAddress = [
                item?.factory_address_shop || 'N/A',
                item?.factory_address_area || 'N/A',
                item?.factory_address_landmark || 'N/A',
                item?.factory_address_city || 'N/A',
                item?.factory_address_state || 'N/A',
                item?.factory_address_pin_code || 'N/A',
              ]
                .filter(text => text !== 'N/A')
                .join(', ')
                .toUpperCase();
              break;
            case 'officeAddress':
              row.officeAddress = [
                item?.office_address_shop || 'N/A',
                item?.office_address_area || 'N/A',
                item?.office_address_landmark || 'N/A',
                item?.office_address_city || 'N/A',
                item?.office_address_state || 'N/A',
                item?.office_address_pin_code || 'N/A',
              ]
                .filter(text => text !== 'N/A')
                .join(', ')
                .toUpperCase();
              break;
            case 'office_address':
              row.officeAddress = item.office_address || 'N/A';
              break;
            case 'phone_number':
              row.phoneNumber = item.phone_number || 'N/A';
              break;
            case 'gstin_number':
              row.gstinNumber = item.gstin_number || 'N/A';
              break;
            case 'pan_number':
              row.panNumber = item.pan_number || 'N/A';
              break;
            case 'udyam_no':
              row.udyamNumber = item.udyam_no || 'N/A';
              break;
            case 'gst_type':
              row.gstType = item.gst_type || 'N/A';
              break;
            case 'created_at':
              row.createdAt = item.created_at
                ? moment(item.created_at).format('DD-MM-YYYY')
                : 'N/A';
              break;
            case 'created_by':
              row.createdBy = item.created_by
                ? `${item.created_by.first_name} ${item.created_by.last_name}`
                : 'N/A';
              break;
            case 'updated_at':
              row.updatedAt = item.updated_at
                ? moment(item.updated_at).format('DD-MM-YYYY')
                : 'N/A';
              break;
            case 'updated_by':
              row.updatedBy = item.created_by
                ? `${item.created_by.first_name} ${item.created_by.last_name}`
                : 'N/A';
              break;
            case 'account_group':
              row.accountGroup = item.account_group.name || 'N/A';
              break;
            case 'customer_type':
              row.customerType = item.customer_type.name || 'N/A';
              break;
            case 'delivery_days':
              row.deliveryDays = item.delivery_days || 'N/A';
              break;
            case 'applicable_gst':
              row.applicableGst = item.applicable_gst || 'N/A';
              break;
            case 'customer_section_no':
              row.customerSectionNo = item.customer_section_no || 'N/A';
              break;
            case 'bank_name':
              row.bankName = item.bank_name || 'N/A';
              break;
            case 'bank_account_number':
              row.bankAccountNumber = item.bank_account_number || 'N/A';
              break;
            case 'bank_ifsc_code':
              row.bankIfscCode = item.bank_ifsc_code || 'N/A';
              break;
            case 'bank_branch_address':
              row.bankBranchAddress = item.bank_branch_address || 'N/A';
              break;
            case 'email':
              row.email = item.email || 'N/A';
              break;
            default:
              break;
          }
        });
        return row;
      });

      const pageWidth = pdf.internal.pageSize.getWidth();
      pdf.setFontSize(16);
      pdf.text('Customer', pageWidth / 2, 40, { align: 'center' });
      const totalWidth = pdf.internal.pageSize.getWidth() - 30; // Adjusted for margins
      const columnWidth = totalWidth / columns.length; // Equal width for each column
      pdf.autoTable({
        columns,
        body: rows,
        startY: 80,
        theme: 'grid',
        margin: { top: 80, right: 15, left: 15, bottom: 40 },
        tableWidth: 'auto',
        styles: {
          halign: 'center',
          overflow: 'linebreak',
          cellPadding: 2,
          fontSize: 9,
          lineWidth: 0.4,
          lineColor: [0, 0, 0],
          textColor: [0, 0, 0],
        },
        headStyles: {
          textColor: [0, 0, 0],
          fontStyle: 'bold',
          lineWidth: 0.4,
          lineColor: [0, 0, 0],
          fillColor: false,
        },
        columnStyles: columns.reduce((acc, col) => {
          acc[col.dataKey] = { cellWidth: columnWidth }; // Set fixed equal width for all columns
          return acc;
        }, {}),
        didDrawPage: data => {
          pdf.setFontSize(8);
          const pageCount = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= pageCount; i++) {
            pdf.setPage(i);
            pdf.text(
              `Page ${i} of ${pageCount}`,
              pdf.internal.pageSize.getWidth() - 50,
              pdf.internal.pageSize.getHeight() - 10,
            );
          }
        },
      });
      pdf.save(`customer${new Date().toISOString().split('T')[0]}.pdf`);
    } catch (error) {
      console.error('PDF generation failed:', error);
    } finally {
      setAllPdfLoading(false);
    }
  };

  const handlePageSizeChange = (current, size) => {
    setPage(1); // Reset to first page if needed
    setPageSize(size); // You must have a setter or state update
  };

  const handlePrintWorkOrder = async (customerName, customerId) => {
    try {
      const params = {
        page: 1,
        pagesize: 1000,
        customer_id: customerId,
      };

      const response = await dispatch(fetchWorkOrderReport(params)).unwrap();
      const orderData = response?.data || [];

      const generateTableRows = () => {
        return orderData
          .map((order, index) => {
            return `
            <tr>
              <td>${index + 1}</td>
            <td >${order.workorder_no || 'N/A'}</td>
              <td>${order.po_no || 'N/A'}</td>
              <td>${order.section || 'N/A'}</td>
              <td>
                ${order.profile_image && order.profile_image !== 'N/A'
                ? `<img src="${order.profile_image}" alt="Profile" class="profile-image" onerror="this.style.display='none';" />`
                : ' '
              }
              </td>
              <td>${order.customer_reference_number || 'N/A'}</td>
              <td>${order.length || 'N/A'}</td>
              <td>${order.order_pcs || ''}</td>
              <td style="text-align: right;">${order.order_kgs ? parseFloat(order.order_kgs).toFixed(3) : ''}</td>
              <td>${order.dispatched_pcs || ''}</td>
              <td style="text-align: right;">${order.dispatched_kgs ? parseFloat(order.dispatched_kgs).toFixed(3) : ''}</td>
              <td>${order.packed_pcs || ''}</td>
              <td style="text-align: right;">${order.packed_kgs ? parseFloat(order.packed_kgs).toFixed(3) : ''}</td>
              <td>${order.warehouse_pcs || ''}</td>
              <td style="text-align: right;">${order.warehouse_kgs ? parseFloat(order.warehouse_kgs).toFixed(3) : ''}</td>
              <td>${order.pending_pcs || ''}</td>
              <td style="text-align: right;">${order.pending_kgs ? parseFloat(order.pending_kgs).toFixed(3) : ''}</td>
              <td>${order.remark || ''}</td>
            </tr>
            `;
          })
          .join('');
      };

      const windowPrint = window.open('', '', 'width=1200,height=800');
      windowPrint.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>Work Order Report</title>
            <style>
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          
          body {
            font-family: Arial, sans-serif;
            font-size: 10px;
            line-height: 1.4;
            color: #333;
            background: white;
          }
          
          .print-container {
            padding: 5px;
            max-width: 100%;
          }
          
          .print-header {
            text-align: center;
            margin-bottom: 30px;
          
          }
          
          .print-header h1 {
            font-size: 24px;
            font-weight: bold;
            margin-bottom: 10px;
            color: #333;
          }
          
          .print-header h2 {
            font-size: 18px;
            color: #666;
            margin-bottom: 5px;
          }
          
          .work-order-table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 20px;
            font-size: 8px;
            border: 2px solid #333;
          }
          
          .work-order-table th,
          .work-order-table td {
            border: 1px solid #666;
            padding: 2px 4px;
            text-align: center;
            vertical-align: middle;
            word-wrap: break-word;
          }
          
          .work-order-table th {
            background-color: #f5f5f5;
            font-weight: bold;
            font-size: 9px;
            text-align: center;
            color: #333;
          }
          
          .work-order-table tr:nth-child(even) {
            background-color: #f9f9f9;
          }
          
          .work-order-table tr:hover {
            background-color: #f0f0f0;
          }
          
          .total-row {
            background-color: #e8f4f8 !important;
            font-weight: bold;
            font-size: 8px;
            border-top: 1px solid #333 !important;
          }
          
          .total-row td {
            border-top: 2px solid #333 !important;
            font-weight: bold;
          }
          
          .profile-image {
            max-width: 50px;
            max-height: 40px;
            display: block;
            margin: 0 auto;
            object-fit: contain;
          }
          
          /* Specific column width controls for Portrait A4 */
          .work-order-table colgroup col:nth-child(1) { width: 3%; }   /* Sr. No */
          .work-order-table colgroup col:nth-child(2) { width: 7%; }   /* Work Order */
          .work-order-table colgroup col:nth-child(3) { width: 7%; }   /* PO No */
          .work-order-table colgroup col:nth-child(4) { width: 5%; }   /* Profile No */
          .work-order-table colgroup col:nth-child(5) { width: 6%; }   /* Profile Image */
          .work-order-table colgroup col:nth-child(6) { width: 8%; }   /* Customer Ref */
          .work-order-table colgroup col:nth-child(7) { width: 5%; }   /* Length */
          .work-order-table colgroup col:nth-child(8) { width: 4%; }   /* Order PCS */
          .work-order-table colgroup col:nth-child(9) { width: 4%; }   /* Order KGS */
          .work-order-table colgroup col:nth-child(10) { width: 4%; }  /* Dispatched PCS */
          .work-order-table colgroup col:nth-child(11) { width: 4%; }  /* Dispatched KGS */
          .work-order-table colgroup col:nth-child(12) { width: 4%; }  /* Packed PCS */
          .work-order-table colgroup col:nth-child(13) { width: 4%; }  /* Packed KGS */
          .work-order-table colgroup col:nth-child(14) { width: 4%; }  /* Warehouse PCS */
          .work-order-table colgroup col:nth-child(15) { width: 4%; }  /* Warehouse KGS */
          .work-order-table colgroup col:nth-child(16) { width: 4%; }  /* Pending PCS */
          .work-order-table colgroup col:nth-child(17) { width: 4%; }  /* Pending KGS */
          .work-order-table colgroup col:nth-child(18) { width: 6%; }  /* Remarks */
          
          @media print {
            body { 
              font-size: 8px; 
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
            .print-container { 
              padding: 2px; 
            }
            .work-order-table { 
              font-size: 8px; 
            }
            .work-order-table th,
            .work-order-table td { 
              padding: 1px 1px; 
              font-size: 8px;
            }
            .profile-image {
              max-width: 30px;
              max-height: 20px;
            }
            .print-header h1 {
              font-size: 16px;
            }
            .print-header h2 {
              font-size: 12px;
            }
          }
          
          @page {
            margin: 0.5in;
            size: A4 portrait;
          }
        </style>
          </head>
          <body>
            <div class="print-container">
              <div class="print-header">
                <h1>Work Order Report</h1>
                <h2>${customerName || 'Customer'}</h2>
              </div>
              <table class="work-order-table">
                <thead>
                  <tr>
                    <th rowspan="2">Sr.<br/>No.</th>
                    <th rowspan="2">Work Order No/<br/>Date</th>
                    <th rowspan="2">PO NO/<br/>Date</th>
                    <th rowspan="2">Profile<br/>No</th>
                    <th rowspan="2">Profile<br/>Image</th>
                    <th rowspan="2">Customer Reference<br/>Number</th>
                    <th rowspan="2">Length<br/>(mm)</th>
                    <th colspan="2">Order</th>
                    <th colspan="2">Dispatched</th>
                    <th colspan="2">Packed</th>
                    <th colspan="2">Warehouse</th>
                    <th colspan="2">Pending</th>
                    <th rowspan="2">Remarks</th>
                  </tr>
                  <tr>
                    <th>PCS</th>
                    <th>KGS</th>
                    <th>PCS</th>
                    <th>KGS</th>
                    <th>PCS</th>
                    <th>KGS</th>
                    <th>PCS</th>
                    <th>KGS</th>
                    <th>PCS</th>
                    <th>KGS</th>
                  </tr>
                </thead>
                <tbody>
                    ${generateTableRows()}
                  <tr class="total-row">
                    <td colspan="7"><strong>Total</strong></td>
                    <td><strong>${orderData.reduce((sum, order) => sum + (parseInt(order.order_pcs) || 0), 0)}</strong></td>
                    <td><strong>${orderData.reduce((sum, order) => sum + (parseFloat(order.order_kgs) || 0), 0).toFixed(3)}</strong></td>
                    <td><strong>${orderData.reduce((sum, order) => sum + (parseInt(order.dispatched_pcs) || 0), 0)}</strong></td>
                    <td><strong>${orderData.reduce((sum, order) => sum + (parseFloat(order.dispatched_kgs) || 0), 0).toFixed(3)}</strong></td>
                    <td><strong>${orderData.reduce((sum, order) => sum + (parseInt(order.packed_pcs) || 0), 0)}</strong></td>
                    <td><strong>${orderData.reduce((sum, order) => sum + (parseFloat(order.packed_kgs) || 0), 0).toFixed(3)}</strong></td>
                    <td><strong>${orderData.reduce((sum, order) => sum + (parseInt(order.warehouse_pcs) || 0), 0)}</strong></td>
                    <td><strong>${orderData.reduce((sum, order) => sum + (parseFloat(order.warehouse_kgs) || 0), 0).toFixed(3)}</strong></td>
                    <td><strong>${orderData.reduce((sum, order) => sum + (parseInt(order.pending_pcs) || 0), 0)}</strong></td>
                    <td><strong>${orderData.reduce((sum, order) => sum + (parseFloat(order.pending_kgs) || 0), 0).toFixed(3)}</strong></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </body>
        </html>
      `);

      windowPrint.document.close();
      windowPrint.focus();

      setTimeout(() => {
        windowPrint.print();
        windowPrint.close();
      }, 500);
    } catch (error) {
      console.error('Error fetching work order data:', error);
      message.error('Failed to generate work order report');
    }
  };

  /*
  display: flex
;
   
    align-items: center;
    justify-content: flex-end;
    padding: 8px;
  
    gap: 15px;
  */
  const masterMenuItems = [
                {
      key: '1',
      label: (
        <>
          {currentUser?.permissions?.permissions?.customer?.includes(
            'view_customercategory',
          ) && (
              <Link to="/customer-category-list">
                <Button
                  type="primary"
                  size="small"
                  icon={<Customercategory />}
                  className="lightblue"
                >
                  Customer Categories
                </Button>
              </Link>
            )}
        </>
      ),
    },
    {
      key: '4',
      label: (
        <>
          {currentUser?.permissions?.permissions?.customer?.includes(
            'view_customertype',
          ) && (
              <Link to="/customer-type-list">
                <Button
                  type="primary"
                  size="small"
                  icon={<Customertype />}
                  className="lightpurple"
                >
                  Customer Types
                </Button>
              </Link>
            )}
        </>
      ),
    },
    {
      key: '5',
      label: (
        <>
          {currentUser?.permissions?.permissions?.customer?.includes(
            'view_sitelocation',
          ) && (
              <Link to="/site-location">
                <Button
                  type="primary"
                  size="small"
                  icon={<Sitelocation />}
                  className="lightgreen"
                >
                  Site Locations
                </Button>
              </Link>
            )}
        </>
      ),
    },
    {
      key: '6',
      label: (
        <>
          {currentUser?.permissions?.permissions?.product?.includes(
            'view_alloy',
          ) && (
              <Link to="/alloy-list">
                <Button
                  type="primary"
                  size="small"
                  icon={<Alloy />}
                  className="darkgreen"
                >
                  Alloy
                </Button>
              </Link>
            )}
        </>
      ),
    },
    {
      key: '7',
      label: (
        <>
          {currentUser?.permissions?.permissions?.product?.includes(
            'view_temper',
          ) && (
              <Link to="/tempers-list">
                <Button
                  type="primary"
                  size="small"
                  icon={<Temper />}
                  className="darkblue"
                >
                  Temper
                </Button>
              </Link>
            )}
        </>
      ),
    },
    {
      key: '8',
      label: (
        <>
          {currentUser?.permissions?.permissions?.die?.includes(
            'view_conversionrate',
          ) && (
              <Link to="/conversion-rate-list">
                <Button
                  type="primary"
                  size="small"
                  icon={<Conversation />}
                  className="lightgreen"
                >
                  Conversion Rate
                </Button>
              </Link>
            )}
        </>
      ),
    },
    {
      key: '9',
      label: (
        <>
          {currentUser?.permissions?.permissions?.die?.includes(
            'view_conversionrate',
          ) && (
              <Link to="/packing-mode">
                <Button
                  type="primary"
                  size="small"
                  icon={<Conversation />}
                  className="lightgreen"
                >
                  Packing Mode
                </Button>
              </Link>
            )}
        </>
      ),
    },
  ];
  const actionMenuItems = [
    {
      key: '1',
      label: (
        <>
          {currentUser?.permissions?.permissions?.customer?.includes(
            'add_customer',
          ) && (
              <Link to="/add-new-customer">
                <Tooltip title="Add New Customer">
                  <Button type="primary" icon={<PlusOutlined />}>
                    Add New Customer
                  </Button>
                </Tooltip>
              </Link>
            )}
        </>
      ),
    },
    // {
    //   key: '2',
    //   label: (
    //     <>
          
             
    //           <Button type="primary"  icon={<UploadOutlined  />} onClick={() => setOpenModal(true)}>

    //                 Import Data
                
    //             </Button>
            
    //     </>
    //   ),
    // },
    {
      key: '3',
      label: (
        <>
          {currentUser?.permissions?.permissions?.customer?.includes(
            'download_customer_pdf_copy',
          ) && (
              <Tooltip placement="top" title={'Export PDF'}>
                <Button
                  type="primary"
                  onClick={exportCustomerPDF}
                  icon={<FilePdfOutlined />}
                >
                  Export PDF
                </Button>
              </Tooltip>
            )}
        </>
      ),
    },
    {
      key: '4',
      label: (
        <>
          {currentUser?.permissions?.permissions?.customer?.includes(
            'download_customer_excel_copy',
          ) && (
              <Tooltip placement="top" title={'Export Excel'}>
                <Button
                  type="primary"
                  icon={<FileExcelOutlined />}
                  onClick={activityLog}
                >
                  <CSVLink
                    style={{ textAlign: 'left' }}
                    filename={'customer.csv'}
                    data={csvListData}
                    headers={csvHeaders}
                  >
                    Export Excel
                  </CSVLink>
                </Button>
              </Tooltip>
            )}
        </>
      ),
    },
  
    {
      key: '5',
      label: (
        <>
          {currentUser?.permissions?.permissions?.customer?.includes(
            'delete_customer',
          ) && (
              <Link to="/archive-customer-list">
                <Tooltip title="Archive">
                  <Button icon={<Archiveicon />} type="primary">
                    Archive List
                  </Button>
                </Tooltip>
              </Link>
            )}
        </>
      ),
    },
  ];
  return (
    <div className='mainwrap'>
      <div className="sticyaction">
        <div className="sticky-header">
          <Row
            className="pagenamerow mb-0 "
            justify="space-between"
            align="middle"
          >
            <Col>
              <h2 style={{ margin: 0 }}>Customers</h2>
              <div className="bredcrumbwrp">
                <Link
                  className="back"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <Back /> BACK
                </Link>
                <Breadcrumb
                  items={[
                    { title: <Link to="/dashboard">Home</Link> },
                    { title: 'Customers' },
                  ]}
                />
              </div>
            </Col>
            <Col>
              <Space size="small">
                <Input
                  placeholder="Search"
                  className="searchbox"
                  prefix={<SearchOutlined />}
                  value={inputValue}
                  style={{ width: 190 }}
                  onChange={handleSearch}
                />
                <Tooltip title="Filter">
                  <Button
                    type="primary"
                    disabled={!search && !orderBy}
                    className="iconlink"
                    onClick={resetFilter}
                  >
                    <FilterIcon />
                  </Button>
                </Tooltip>
                <div className="gridiconswrap">
                  <Tooltip placement="topLeft" title="Column Filter Options">
                    <Dropdown
                      overlay={columnMenu}
                      trigger={['click']}
                      placement="bottomRight"
                      visible={dropdownVisible}
                      onVisibleChange={setDropdownVisible}
                    >
                      <Button
                        type="primary"
                        icon={<ColumnList />}
                        onClick={e => e.preventDefault()}
                      />
                    </Dropdown>
                  </Tooltip>
                </div>
              </Space>
              {currentUser?.permissions?.permissions?.customer?.includes(
                'add_customer' || 'download_customer_pdf_copy' || 'download_customer_excel_copy' || 'delete_customer',
              ) && (
                  <Dropdown
                    menu={{ items: actionMenuItems }}
                    trigger={['click']}
                    overlayClassName="mastermenu pageactionmenu"
                  >
                    <Button type="primary" style={{ marginLeft: '10px' }}>
                      Action <DownOutlined />
                    </Button>
                  </Dropdown>
                )}
              {/* {currentUser?.permissions?.permissions?.customer?.includes(
 'view_accountgroup' || 'view_customercategory' || 'view_customertype' || 'view_sitelocation' || 'view_alloy' || 'view_temper',
              ) && (
                  <Dropdown
                    menu={{ items: masterMenuItems }}
                    trigger={['click']}
                    overlayClassName="mastermenu"
                  >
                    <Button type="primary" style={{ marginLeft: '10px' }}>
                      Master <DownOutlined />
                    </Button>
                  </Dropdown>
                )} */}
            </Col>
          </Row>
        </div>
      </div>
      <ImportDataModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        refreshTable={refreshTable}
        formatFilePath={formatFile}
        model={"customer"}
      />
      {(
        currentUser?.permissions?.permissions?.customer?.includes('view_customer') ||
        currentUser?.permissions?.permissions?.customer?.includes('change_customer') ||
        currentUser?.permissions?.permissions?.customer?.includes('print_customer_workorder_report_pdf_copy') ||
        currentUser?.permissions?.permissions?.customer?.includes('delete_customer') ||
        currentUser?.permissions?.permissions?.customer?.includes('add_customer') ||
        currentUser?.permissions?.permissions?.customer?.includes('download_customer_pdf_copy') || currentUser.permissions.permissions.customer.includes('download_customer_excel_copy')
      ) ? (
        <>
          <div className='tablewrp'>
            <Table
              rowKey="id"
              // rowSelection={rowSelection}
              columns={filteredColumns}
              dataSource={data}
              pagination={false} // Disable built-in pagination
              loading={status === 'loading'}
              onChange={handleTableChange}
              scroll={{ x: '1000px' }}
            />
          </div>



          <Pagination
            current={page}
            pageSize={pagesize}
            total={totalRecord}
            showSizeChanger
            onShowSizeChange={handlePageSizeChange}
            pageSizeOptions={['10', '50', '100']}
            showTotal={total => `Total ${total} items`}
            onChange={handlePageChange}
            locale={{ items_per_page: 'Items / Page' }}
          />
        </>
      ) : (
        <div style={{ padding: '2rem', textAlign: 'center', fontSize: '20px' }}>
          You have no permission to see.
        </div>
      )}

    </div>
  );
}

export default CustomerList;
